export default [
  {
    path: "/student",
    name: "student",
    component: () => import("@/views/student/index.vue"),
    meta: {
      title: "学籍查询"
    }
  }
];
